import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { trackNavigateEvent } from 'utilities/posthog-tracking';

export const SearchbarFavouriteLocationLink = ({
  disabled,
  link,
  children,
}: {
  disabled: boolean;
  link: string;
  children: JSX.Element;
}) => {
  if (disabled) {
    <div className="SearchBar-favourites-list-item__content">{children}</div>;
  }

  return (
    <LinkFactoryReactRouter
      className="SearchBar-favourites-list-item__content"
      href={link}
      onClick={() => trackNavigateEvent('favourite_widget', 'favourite_link')}
    >
      {children}
    </LinkFactoryReactRouter>
  );
};
